/**
 * Central version management
 * Import version from package.json to have a single source of truth
 */

import packageJson from '../../../package.json';

export const VERSION = packageJson.version;
